import React from 'react';

import GalleryDemoLayout from './GalleryDemoLayout';
import { useGalleryLightbox } from './GalleryLightbox';
import { PHOTOS } from './galleryDemoData';

/* Demo 4 — Expanding accordion wall. Thin panels side by side; hover expands
   one to reveal the photo + caption. Click opens the lightbox. */
const PANELS = PHOTOS.slice(0, 7);

const GalleryAccordion = () => {
    const lb = useGalleryLightbox(PHOTOS);

    return (
        <GalleryDemoLayout
            demoLabel="Demo 4"
            kicker="Expanding Accordion"
            title="Slide To Reveal"
            lead="Glide across the panels — each one expands to reveal the moment inside. Click an open panel to view it full-screen."
        >
            <div className="wrap">
                <div className="gacc reveal">
                    {PANELS.map((p, i) => (
                        <button
                            type="button"
                            className={"gacc__item" + (i === 0 ? " is-open" : "")}
                            key={i}
                            onClick={() => lb.open(i)}
                            aria-label={`View photo: ${p.cap}`}
                        >
                            <img src={p.src} alt={p.cap} loading="lazy" draggable="false" />
                            <span className="gacc__num">{String(i + 1).padStart(2, '0')}</span>
                            <span className="gacc__cap">{p.cap}</span>
                        </button>
                    ))}
                </div>
            </div>
            {lb.lightbox}
        </GalleryDemoLayout>
    );
};

export default GalleryAccordion;
